import React from "react";
import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const PartnerWithAptech =()=>{

    return(
        <div>
              <MetaComponent
                title="Partner with Aptech Limited for Leading Franchise Opportunities"
                desc="Aptech Limited offers franchise opportunities to partner with a leading vocational training center network. Build a successful business while shaping futures. Join today."
                keywords="partnership opportunities, business partners, partner with aptech"
            />
            <PartnerWithAptechSection />
        </div>
    )
}

export default PartnerWithAptech